import React from 'react';
import '@lottiefiles/lottie-player'; // import web component
import Header from '../../components/public/Header';
import TorchEffect from '../../components/torchEffect/TorchEffect';


function ThankYou() {
    return (
        <TorchEffect whiteBG autoHeight style={{ backgroundColor: "rgba(0,0,0,0.4)", width: "100%" }}>
            <div className='h-screen flex items-center'>
                <Header liftHeader={true} prompt />
                <div className='w-full max-w-[642px] m-auto bg-[#fafafa] sm:bg-[#fafbfc]  rounded-[24px] border border-[#ededed]'>
                    <div className='w-full p-9'>
                        <lottie-player
                            autoplay
                            src="/assets/lottie/SendMessage.json"
                            class="w-full max-w-[500px] h-[200px] sm:h-[250px] md:h-[300px] lg:h-[350px] xl:h-[400px] mx-auto my-[-36px] rounded-xl"
                        ></lottie-player>
                        <div className='flex flex-col gap-4 justify-center items-center'>
                            <p className='text-[#1d1415] font-semibold text-[24px] sm:test-[28px] md:text-[32px]'>Thank You! We’ve Received Your Request</p>
                            <div className='className=text-[#433c3d]'>
                                <p >Your details have been submitted successfully.</p>
                                <p>One of our experts will get in touch with you shortly to understand your needs better.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TorchEffect>
    );
}

export default ThankYou;
